"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/MeatballMenu/index.ts
var MeatballMenu_exports = {};
__export(MeatballMenu_exports, {
  MeatballMenu: () => MeatballMenu,
  MeatballMenuContainer: () => MeatballMenuContainer,
  MeatballMenuItem: () => MeatballMenuItem,
  MeatballMenuItemTheme: () => MeatballMenuItemTheme
});
module.exports = __toCommonJS(MeatballMenu_exports);

// src/components/MeatballMenu/MeatballMenuContainer.tsx
var import_react2 = __toESM(require("react"));
var import_classnames2 = __toESM(require("classnames"));

// src/components/MeatballMenu/MeatballMenuItem.tsx
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
var MeatballMenuItemTheme = /* @__PURE__ */ ((MeatballMenuItemTheme2) => {
  MeatballMenuItemTheme2["Primary"] = "default";
  MeatballMenuItemTheme2["Red"] = "red";
  return MeatballMenuItemTheme2;
})(MeatballMenuItemTheme || {});
function MeatballMenuItem({
  id,
  logo,
  label,
  className,
  theme = "default" /* Primary */,
  onClick
}) {
  return /* @__PURE__ */ import_react.default.createElement(
    "li",
    {
      id,
      className: (0, import_classnames.default)(
        "meatball-menu-item",
        className,
        [
          "v2-flex v2-items-center v2-gap-x-4 v2-px-4 v2-py-1 v2-select-none",
          "v2-cursor-pointer v2-font-circular v2-text-sm v2-font-medium"
        ],
        {
          "v2-text-neutral-900 hover:v2-bg-yellow-100": theme === "default" /* Primary */,
          "v2-text-orange-700 hover:v2-bg-magenta-50": theme === "red" /* Red */
        }
      ),
      onClick
    },
    logo,
    label
  );
}

// src/components/MeatballMenu/MeatballMenuContainer.tsx
function MeatballMenuContainer({
  active,
  items,
  className
}) {
  return /* @__PURE__ */ import_react2.default.createElement(
    "ul",
    {
      className: (0, import_classnames2.default)(
        className,
        [
          "v2-h-auto v2-block v2-relative v2-bg-white v2-drop-shadow v2-rounded",
          "v2-p-0 v2-m-0"
        ],
        {
          "v2-animate-fade-in-up-150": active,
          "v2-animate-fade-out-down-150": !active
        }
      )
    },
    items == null ? void 0 : items.map((item, index) => {
      return /* @__PURE__ */ import_react2.default.createElement(MeatballMenuItem, __spreadValues({ key: `meatball-menu-item-${index}` }, item));
    })
  );
}

// src/components/MeatballMenu/MeatballMenu.tsx
var import_react4 = __toESM(require("react"));
var import_classnames3 = __toESM(require("classnames"));
var import_react_tiny_popover = require("react-tiny-popover");

// node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var faEllipsis = {
  prefix: "fas",
  iconName: "ellipsis",
  icon: [448, 512, ["ellipsis-h"], "f141", "M120 256c0 30.9-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56zm160 0c0 30.9-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56zm104 56c-30.9 0-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56s-25.1 56-56 56z"]
};
var faEllipsisH = faEllipsis;

// src/components/MeatballMenu/MeatballMenu.tsx
var import_react_fontawesome = require("@fortawesome/react-fontawesome");

// src/hook/use-delayed-state-hook.ts
var import_react3 = require("react");
function useDelayedState(dependency, delayDuration = 150) {
  const [state, setState] = (0, import_react3.useState)(dependency);
  (0, import_react3.useEffect)(() => {
    setTimeout(() => setState(dependency), dependency ? 0 : delayDuration);
  }, [dependency]);
  return state;
}

// src/components/MeatballMenu/MeatballMenu.tsx
function MeatballMenu({
  positions = ["bottom"],
  align = "end",
  padding = 5,
  className,
  containerClassName,
  bodyClassName,
  containerRef,
  reposition,
  items,
  disabled = false
}) {
  const ref = containerRef != null ? containerRef : (0, import_react4.useRef)(null);
  const [open, setOpen] = (0, import_react4.useState)(false);
  const delayedOpenState = useDelayedState(open);
  const onClick = () => {
    if (!disabled) {
      setOpen(!open);
    }
  };
  return /* @__PURE__ */ import_react4.default.createElement(
    import_react_tiny_popover.Popover,
    {
      ref,
      containerClassName: (0, import_classnames3.default)(className, "meatball-menu v2-z-99"),
      isOpen: delayedOpenState,
      onClickOutside: () => setOpen(false),
      padding,
      content: /* @__PURE__ */ import_react4.default.createElement(
        MeatballMenuContainer,
        {
          active: open,
          className: containerClassName,
          items
        }
      ),
      positions,
      align,
      reposition
    },
    /* @__PURE__ */ import_react4.default.createElement(
      "div",
      {
        className: (0, import_classnames3.default)(
          bodyClassName,
          [
            "v2-cursor-pointer v2-rounded-full v2-w-[30px] v2-h-[30px]",
            "v2-self-center v2-flex v2-justify-center v2-items-center"
          ],
          {
            "v2-bg-yellow-500 v2-text-neutral-900": open,
            "v2-text-neutral-500 hover:v2-bg-yellow-200": !open && !disabled,
            "v2-text-neutral-200 v2-cursor-not-allowed": !open && disabled
          }
        ),
        onClick
      },
      /* @__PURE__ */ import_react4.default.createElement(import_react_fontawesome.FontAwesomeIcon, { icon: faEllipsisH, className: "v2-text-xl" })
    )
  );
}
